const React = require('react');

const Container = require('../common/Container.jsx');
const _TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

function Address(props) {
    const data = props.data || {};
    const config = props.config || {};
    let blockProps = {};
    let includes = {};
    if (config.Config) {
        if (config.Config.Block) {
            blockProps = config.Config.Block;
        }
        if (config.Config.Includes) {
            includes = config.Config.Includes;
        }
    }

    // Determine the visible address and contact information
    const styleAddress = Utilities.Config.getStyle(data, blockProps, '');
    styleAddress.marginBottom = undefined;
    const addressLineStyle = { ...styleAddress };
    if (!Utilities.isNullOrWhitespace(blockProps.lineSpacing)) {
        addressLineStyle.marginTop = blockProps.lineSpacing;
    }
    const content = [];
    if (includes.ContactName && !Utilities.isNullOrWhitespace(data.ConsignerConsigneeName)) {
        content.push(<div key="name">{data.ConsignerConsigneeName}</div>);
    }
    if (includes.SpouseName && !Utilities.isNullOrWhitespace(data.ConsignerConsigneeSpouseName)) {
        content.push(<div key="spouse">{data.ConsignerConsigneeSpouseName}</div>)
    }
    if (data.ConsignerConsigneeAddress) {
        if (!Utilities.isNullOrWhitespace(data.ConsignerConsigneeAddress.LineOne)) {
            content.push(<div key="line1" style={content.length > 0 ? addressLineStyle : undefined}>{data.ConsignerConsigneeAddress.LineOne}</div>);
        }
        if (!Utilities.isNullOrWhitespace(data.ConsignerConsigneeAddress.LineTwo)) {
            content.push(<div key="line2" style={content.length > 0 ? addressLineStyle : undefined}>{data.ConsignerConsigneeAddress.LineTwo}</div>);
        }
        if (!Utilities.isNullOrWhitespace(data.ConsignerConsigneeAddress.LocationWithZip)) {
            content.push(<div key="location" style={content.length > 0 ? addressLineStyle : undefined}>{data.ConsignerConsigneeAddress.LocationWithZip}</div>);
        }
        if (!Utilities.isNullOrWhitespace(data.ConsignerConsigneeAddress.Country)) {
            content.push(<div key="country" style={content.length > 0 ? addressLineStyle : undefined}>{data.ConsignerConsigneeAddress.Country}</div>);
        }
    }
    if (includes.Phone && !Utilities.isNullOrWhitespace(data.ConsignerConsigneePhone)) {
        content.push(<div key="phone" style={content.length > 0 ? addressLineStyle : undefined}>{data.ConsignerConsigneePhone}</div>);
    }
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            onClick={props.onClick}
            onDragStart={props.onDragStart}>
            <tr>
                <td>
                    {
                        content.length > 0 &&
                        <div style={styleAddress}>{content}</div>
                    }
                    {
                        props.builder &&
                        <React.Fragment>
                            {
                                content.length == 0 &&
                                Utilities.Builder.emptyBlockPlaceholder()
                            }
                            {Utilities.Builder.dragOutline()}
                        </React.Fragment>
                    }

                </td>
            </tr>
        </Container>
    );
}

const TypeConfig = {
    panel: {
        block: function () {
            return {
                label: 'Block Configuration',
                options: _TypeConfig.options.text({}, {}, {}, {})
            };
        },
        includes: function () {
            return {
                expanded: false,
                label: 'Include',
                options: [
                    { display: 'Consigner Name', name: 'ContactName', type: 'checkbox', value: true },
                    { display: 'Spouse Name', name: 'SpouseName', type: 'checkbox', value: true },
                    { display: 'Phone', name: 'Phone', type: 'checkbox', value: true }
                ]
            };
        },
        style: function () { return _TypeConfig.panel.layoutStyle({}, {}); }
    }
};

module.exports = {
    Component: Address,
    TypeConfig
};